import { useCallback, useEffect, useRef } from 'react';
import { initWebGL2D, renderWebGL2D, updateWebGL2DData } from './renderWebGL2D';
import { TpWebGl2DContext, TpWebGl2DScale } from './interfaces';

import { TpWebGL2DRenderData } from './interface-renderData';

interface TpCanvasWebGL {
  renderData: TpWebGL2DRenderData;
  scaleX: TpWebGl2DScale;
  scaleY: TpWebGl2DScale;
  registerContext: (ctx: TpWebGl2DContext) => void;
}

export function CanvasWebGL(props: TpCanvasWebGL) {
  const webGlContextRef = useRef<TpWebGl2DContext | null>(null);

  const pixelRatio = 2; // Conversion ratio of canvas to device pixels. Hardwired for now. @todo: fetch the optimal value fro device settings

  const initCanvasCallBack = useCallback((canvas: any) => {
    if (canvas) {
      // Initialize the WebGL context
      canvas.width = canvas.clientWidth * pixelRatio;
      canvas.height = canvas.clientHeight * pixelRatio;
      const ctx = initWebGL2D(canvas, props.renderData, props.scaleX, props.scaleY, pixelRatio);
      webGlContextRef.current = ctx;
      props.registerContext(ctx);
    }
  }, []);

  useEffect(() => {
    const ctx = webGlContextRef.current;
    if (ctx) {
      // Automatically adjust the canvas resolution to the new element size
      // NOTE: this only works if, at a higher level, this is wrapped in a component that cases a rerender on resize (e.g. ResizeObsewrver)
      const style = getComputedStyle(ctx.canvas);
      const width = +style.getPropertyValue('width').slice(0, -2);
      const height = +style.getPropertyValue('height').slice(0, -2);
      ctx.canvas.width = width * pixelRatio;
      ctx.canvas.height = height * pixelRatio;
      renderWebGL2D(ctx);
    }
  });

  if (webGlContextRef.current) {
    // we have an active context, but might need to update the data
    const ctx = webGlContextRef.current;
    updateWebGL2DData(ctx, props.renderData);
  }

  //@todo: on destruction of this element, detroy all webgl related stuff (gl.deleteBuffer, gl.deleteShader, gl.deleteShader)

  return (
    <div style={{ width: '100%', height: '100%' }}>
      <canvas ref={initCanvasCallBack} style={{ width: '100%', height: '100%' }} />
    </div>
  );
}
